import { useIdentityAuthentication } from "hooks/useIdentityAuthentication";

export const useAuthenticator = () => {
	const authenticator = useIdentityAuthentication();

	const token = (): string => {
		return authenticator.getToken();
	};

	const login = async (email: string): Promise<void> => {
		await authenticator.startMicrosoftLogin(email);
	};

	const loginWithPassword = async (
		email: string,
		password: string
	): Promise<void> => {
		await authenticator.loginWithPassword(email, password);
	};

	const completeLogin = async (): Promise<boolean> => {
		return await authenticator.completeSSOLogin();
	};

	const logout = async (): Promise<void> => {
		await authenticator.logout();
	};

	const isLogged = (): boolean => {
		return authenticator.userIsLogged();
	};

	return {
		login,
		loginWithPassword,
		completeLogin,
		isLogged,
		logout,
		token,
	};
};
